import React from 'react';

export function Steak() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.8882 8.47822L19.5095 5.85555C19.1994 5.54551 18.9705 5.16378 18.8431 4.74417C18.7158 4.32455 18.6939 3.88 18.7793 3.44989C18.8648 3.01978 19.055 2.61738 19.3331 2.27835C19.6113 1.93931 19.9687 1.67409 20.3738 1.50619C20.7789 1.33829 21.2192 1.27288 21.6556 1.31576C22.092 1.35864 22.5111 1.50848 22.8758 1.75202C23.2405 1.99556 23.5395 2.32527 23.7463 2.71195C23.9531 3.09864 24.0614 3.53036 24.0615 3.96888C24.5002 3.96857 24.9321 4.07646 25.3191 4.283C25.706 4.48953 26.0361 4.78834 26.2799 5.15292C26.5238 5.51751 26.674 5.93663 26.7171 6.37314C26.7603 6.80964 26.6951 7.25005 26.5274 7.65534C26.3596 8.06064 26.0945 8.41829 25.7555 8.69662C25.4165 8.97494 25.014 9.16534 24.5838 9.25094C24.1536 9.33654 23.709 9.3147 23.2892 9.18736C22.8695 9.06001 22.4876 8.83109 22.1775 8.52088L19.7509 10.9489"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-primary"
            />
            <path
                d="M6.59955 22.0973C10.2444 25.7422 14.4655 27.4307 16.0276 25.8686C17.5897 24.3065 15.9013 20.0854 12.2564 16.4405C8.61151 12.7956 4.39041 11.1072 2.82831 12.6692C1.26621 14.2313 2.95465 18.4524 6.59955 22.0973Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-primary"
            />
            <path
                d="M16.0283 25.8689C21.2349 20.6609 22.5016 13.4849 18.8563 9.84087C15.2123 6.19554 8.03626 7.4622 2.82959 12.6689M8.72826 18.6355L10.0616 19.9689L8.72826 18.6355Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-primary"
            />
        </svg>
    );
}
